/** Progressive brand search. The complete directory remains usable without JavaScript. */
class LocalOutletBrands extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const search = this.querySelector('[data-brand-search]');
    const input = search?.querySelector('input');
    if (!input) return;
    search.hidden = false;
    const cards = [...this.querySelectorAll('[data-brand-name]')];
    const update = () => {
      const query = input.value.trim().toLocaleLowerCase();
      let count = 0;
      for (const card of cards) {
        card.hidden = !card.dataset.brandName.toLocaleLowerCase().includes(query);
        if (!card.hidden) count++;
      }
      const status = this.querySelector('[data-brand-count]');
      if (status) status.textContent = `${String(count).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      this.querySelector('[data-brand-empty]').hidden = count > 0;
    };
    input.addEventListener('input', update, { signal: this.controller.signal });
    update();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}
if (!customElements.get('lo-brand-directory')) customElements.define('lo-brand-directory', LocalOutletBrands);
